document.addEventListener('DOMContentLoaded', function () {
    function initializeForm(formId) {
        const form = document.getElementById(formId);
        if (!form) return;

        const steps = Array.from(form.querySelectorAll('.step'));
        const nextButtons = Array.from(form.querySelectorAll('.next'));
        const prevButtons = Array.from(form.querySelectorAll('.prev'));
        const progressBar = form.querySelector('.progress');
        const progressPercent = form.querySelector('.progress-percent');
        const singleChoiceCheckboxes = form.querySelectorAll('.single-choice');
        const thankYouMessage = form.querySelector(`#${formId}-thank-you-message`);
        const finalStep = form.querySelector(`#${formId}-final-step`);
        const calendlyStep = form.querySelector(`#${formId}-calendly-step`);

        let currentStep = 0;

        function showStep(step) {
            steps.forEach((stepElement, index) => {
                stepElement.classList.toggle('active', index === step);
            });
            updateProgressBar(step);
        }

        function updateProgressBar(step) {
            let progress = ((step + 1) / (steps.length - 1)) * 100;
            if (progress > 100) {
                progress = 100;
            }
            progressBar.style.width = progress + '%';
            progressPercent.textContent = Math.round(progress) + '%';
        }

        if (singleChoiceCheckboxes.length > 0) {
            singleChoiceCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    if (checkbox.checked) {
                        singleChoiceCheckboxes.forEach(otherCheckbox => {
                            if (otherCheckbox !== checkbox) {
                                otherCheckbox.checked = false;
                            }
                        });
                    }
                });
            });
        }

        function isAtLeastOneCheckboxChecked(stepIndex) {
            const checkboxes = steps[stepIndex].querySelectorAll('input[type="checkbox"]');
            return Array.from(checkboxes).some(checkbox => checkbox.checked);
        }


        nextButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                const errorMessageDiv = steps[currentStep].querySelector('.error-message');
                if (!isAtLeastOneCheckboxChecked(currentStep)) {
                    errorMessageDiv.textContent = 'Sie müssen mindestens ein Kontrollkästchen auswählen, um fortzufahren.';
                    errorMessageDiv.style.display = 'block';
                    errorMessageDiv.style.marginTop = '10px';
                    return;
                } else {
                    errorMessageDiv.style.display = 'none';
                }

                if (currentStep === steps.length - 3) {
                    const selectedOption = form.querySelector('input[name="step4"]:checked');
                    if (selectedOption && selectedOption.value === 'Ich bin bereit und will jetzt sofort mit der MPU Beratung starten') {
                        calendlyStep.style.display = 'block';
                        finalStep.style.display = 'none';
                    } else {
                        finalStep.style.display = 'block';
                        loadFormAjax = true;
                        attachFormSubmitHandler(form);
                        calendlyStep.style.display = 'none';
                    }
                    currentStep++;
                } else {
                    currentStep++;
                }
                showStep(currentStep);
            });
        });


        prevButtons.forEach((button) => {
            button.addEventListener('click', () => {
                if (currentStep === steps.length - 2) {  // Assuming final step is steps.length - 1
                    finalStep.style.display = 'none';
                }
                currentStep--;
                showStep(currentStep);
            });
        });

        function attachFormSubmitHandler(form) {
            const ajaxurl = '/wp-admin/admin-ajax.php';
            const spinner = form.querySelector('.spinner-border');

            if (form) {
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    console.log('Form submitted');

                    spinner.style.display = 'inline-block'; 

                    const formData = new FormData(form);

                    const stepData = {};
                    const steps = Array.from(form.querySelectorAll('.step'));
                    steps.forEach((stepElement, index) => {
                        if (index < steps.length - 2) {
                            const checkboxes = stepElement.querySelectorAll('input[type="checkbox"]:checked');
                            stepData[`step${index + 1}`] = Array.from(checkboxes).map(cb => cb.value);
                        }
                    });

                    formData.forEach((value, key) => {
                        stepData[key] = value;
                    });

                    stepData['action'] = 'handle_custom_form_submission'; // Ensure the action is set correctly
                    stepData['nonce'] = form.querySelector('[name="nonce"]').value;

                    console.log('Sending data to backend:', stepData);

                    const params = new URLSearchParams();
                    for (const key in stepData) {
                        if (Array.isArray(stepData[key])) {
                            stepData[key].forEach(value => params.append(key + '[]', value));
                        } else {
                            params.append(key, stepData[key]);
                        }
                    }

                    fetch(ajaxurl, {
                        method: 'POST',
                        body: params,
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }).then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    }).then(data => {
                        if (data.success) {
                            spinner.style.display = 'none'; 
                            // Prikazivanje "Thank you" poruke
                            thankYouMessage.style.display = 'block';
                            finalStep.style.display = 'none';
                            updateProgressBar(steps.length - 2); // Postavljanje progresne trake na 100%
                            console.log('Form submitted successfully!');
                        } else {
                            console.error('Error:', data);
                        }
                    }).catch(error => {
                        console.error('Error:', error);
                    });
                });
            } else {
                console.error('Form not found!');
            }
        }

        showStep(currentStep);
    }

    // Inicijalizacija za svaku formu
    initializeForm('step-form');
    initializeForm('step-form-2');
    initializeForm('step-form-3');
});
